import { Link } from 'react-router-dom';
import AuthHeaderActions from './AuthHeaderActions';
import { useTranslation } from '../../i18n/LocaleContext';

/**
 * 登入／註冊共用外殼（深色玻璃擬態彈窗）
 */
export default function AuthModalShell({
  mode = 'login',
  title,
  children,
}) {
  const { t } = useTranslation();

  return (
    <div className="auth-modal">
      <div className="auth-modal__header">
        <div className="auth-modal__brand">
          <span className="auth-modal__brand-icon" aria-hidden>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.03-2.48-.49-4.05-1.66-4.05-3.89 0-1.84 1.61-3.11 3.7-3.44V4h2.67v1.95c1.71.35 2.98 1.4 3.12 3.15h-1.96c-.12-.84-.64-1.5-2.16-1.5-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.05 1.55 4.05 3.89c-.01 1.97-1.49 3.15-3.66 3.55z"
                fill="currentColor"
              />
            </svg>
          </span>
          <span className="auth-modal__brand-text">Formosa</span>
        </div>
        <AuthHeaderActions />
      </div>

      <div className="auth-modal__toggle">
        <Link
          to="/register"
          className={`auth-modal__toggle-item ${mode === 'register' ? 'is-active' : ''}`}
        >
          {t('auth.navRegister')}
        </Link>
        <Link
          to="/login"
          className={`auth-modal__toggle-item ${mode === 'login' ? 'is-active' : ''}`}
        >
          {t('auth.navLogin')}
        </Link>
      </div>

      {title && <h1 className="auth-modal__title">{title}</h1>}

      {children}
    </div>
  );
}
